module.exports = __webpack_public_path__ + "static/safari-33eb13c2ad70a76d06436c4ffe93fcf7.png";